import * as React from 'react';

import { TUseCadastreInputProps, ICadastreInputProps } from '../types';

export function useCadastreInput({ value, error, onChange, onBlur }: TUseCadastreInputProps): ICadastreInputProps {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value || null),
    [onChange],
  );

  return {
    value: value || '',
    error,
    onChange: handleChange,
    onBlur,
  };
}
